import { http } from '@/api/Connect';
import { BASE_OPERATOR } from '@/api/CopyStake/BaseUrls';
import { AxiosResponse } from 'axios';

import { TOperatorWebhooks, TOperatorWebhooksPayload } from '@/api/schema';

const API_OPERATOR_WEBHOOKS = (): string => `${BASE_OPERATOR()}/webhook`;

export async function getWebhookConfiguration(): Promise<TOperatorWebhooks> {
  return http
    .get(API_OPERATOR_WEBHOOKS())
    .then(({ data }: AxiosResponse<TOperatorWebhooks>) => data);
}

export async function updateWebhookUrlsConfiguration(
  payload: Partial<TOperatorWebhooksPayload>
): Promise<TOperatorWebhooks> {
  return http
    .put(API_OPERATOR_WEBHOOKS(), payload)
    .then(({ data }: AxiosResponse<TOperatorWebhooks>) => data);
}

export async function toggleWebhooksOperatorState(
  status: boolean
): Promise<TOperatorWebhooks> {
  return http
    .patch(API_OPERATOR_WEBHOOKS(), null, {
      params: {
        enabled: status
      }
    })
    .then(({ data }: AxiosResponse): TOperatorWebhooks => data);
}
